import { Card, NoticeBox, Switch, Mail, Bell } from "../ui";

// Notification preferences of the signed-in user (Copilot e-mails and in-app
// notifications). Two switches; required messages are not covered by them.
// Styling is inline on purpose: it only uses the widget's --lc-* tokens and
// logical properties, so it follows the widget's RTL/LTR direction.
const S = {
  wrap: { display: "flex", flexDirection: "column", gap: 12, padding: 14, minWidth: 0, maxWidth: "100%", boxSizing: "border-box", overflowX: "hidden" },
  head: { display: "flex", flexDirection: "column", gap: 2 },
  title: { margin: 0, fontSize: 15, fontWeight: 700, color: "var(--lc-ink)" },
  sub: { margin: 0, fontSize: 12, lineHeight: 1.5, color: "var(--lc-muted)" },
  row: { display: "flex", alignItems: "center", gap: 12, minWidth: 0 },
  icon: { flex: "0 0 auto", width: 34, height: 34, display: "grid", placeItems: "center", borderRadius: 10, background: "var(--lc-chip)", color: "var(--lc-brand)" },
  text: { display: "flex", flexDirection: "column", gap: 2, minWidth: 0, overflowWrap: "anywhere" },
  label: { fontSize: 13, fontWeight: 600, color: "var(--lc-ink)" },
  hint: { fontSize: 12, lineHeight: 1.45, color: "var(--lc-muted)", fontWeight: 400 },
};

export default function SettingsView({ c }) {
  const { t, prefs } = c;
  const loading = prefs.status === "loading" || prefs.status === "idle";

  const row = (key, Icon, label, hint) => (
    <Card key={key} padding="sm" hoverable={false}>
      <div style={S.row}>
        <span style={S.icon} aria-hidden="true"><Icon size={18} /></span>
        <Switch
          checked={Boolean(prefs[key])}
          disabled={loading}
          onChange={(event) => c.setPreference(key, event.target.checked)}
          label={
            <span style={S.text}>
              <strong style={S.label}>{label}</strong>
              <span style={S.hint}>{hint}</span>
            </span>
          }
        />
      </div>
    </Card>
  );

  return (
    <div style={S.wrap} className="lc-settings">
      <div style={S.head}>
        <h3 style={S.title}>{t.settings}</h3>
      </div>
      {prefs.status === "error" && <NoticeBox variant="danger" size="sm">{prefs.error}</NoticeBox>}
      {row("email", Mail, t.settingsEmail, t.settingsEmailHint)}
      {row("inApp", Bell, t.settingsInApp, t.settingsInAppHint)}
      {prefs.status === "ready" && prefs.error && <NoticeBox variant="danger" size="sm">{prefs.error}</NoticeBox>}
      <NoticeBox variant="info" size="sm">{t.settingsNote}</NoticeBox>
    </div>
  );
}
